import angular from 'angular';

import routing from './fact.routes';
import FactCtrl from './fact.controller';

import fbFact from '../../components/fb-fact'
import lfActionGuide from '../../directives/lf-action-guide'
import lfCaseList from '../../directives/lf-case-list'
import CurrentCase from '../../models/case'
import lfUpdateNotification from '../../directives/lf-update-notification';
import statusNav from '../../directives/status-message/status-nav'

export default angular.module('app.fact', [
    fbFact,
    lfActionGuide,
    lfCaseList,
    lfUpdateNotification,
    statusNav,
    CurrentCase
  ])
  .config(routing)
  .controller('FactCtrl', FactCtrl)
  .name;



// WEBPACK FOOTER //
// ./project/pages/fact/index.js